module.exports = __webpack_public_path__ + "5.0.2/img/preview_pc.7114a25c.png";